import React, { useState } from "react";

// Mock data for News List
const initialNewsList = [
  {
    srNo: 1,
    title: "Scheduled Maintenance",
    description:
      "Dear Valued Customer, Namaste, Due to a scheduled maintenance activity all services will not be available from 22 September 2022 00:00 to 24 September 2022 02:00 AM. We appreciate your patience and understanding. As always, if you have questions or issues, please feel free to contact the Support Team. Thanks & Regards -Team ODHPAY",
    status: "Block",
  },
  {
    srNo: 2,
    title: "Downtime BSNL",
    description:
      "Dear User, The issue with the BSNL Prepaid (Biller Id:BILAVBSNL00001) biller is resolved. We appreciate your patience during this times.Best Regards, ODHPAY Team.",
    status: "Block",
  },
];

const AddNews = () => {
  const [newsTitle, setNewsTitle] = useState("");
  const [newsDescription, setNewsDescription] = useState("");
  const [newsList, setNewsList] = useState(initialNewsList);

  const handleAddNews = () => {
    if (newsTitle && newsDescription) {
      const newNews = {
        srNo: newsList.length + 1,
        title: newsTitle,
        description: newsDescription,
        status: "Block", // Default status is Block
      };
      setNewsList([...newsList, newNews]);
      setNewsTitle("");
      setNewsDescription("");
    } else {
      alert("Please enter both title and description.");
    }
  };

  const handleToggleStatus = (srNo) => {
    const updatedList = newsList.map((news) =>
      news.srNo === srNo ? { ...news, status: news.status === "Block" ? "Unblock" : "Block" } : news
    );
    setNewsList(updatedList);
  };

  const handleEditNews = (srNo) => {
    const newsToEdit = newsList.find((news) => news.srNo === srNo);
    setNewsTitle(newsToEdit.title);
    setNewsDescription(newsToEdit.description);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Add News</h2>
      <div style={styles.formSection}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>News Title</label>
          <input
            type="text"
            value={newsTitle}
            onChange={(e) => setNewsTitle(e.target.value)}
            style={styles.input}
            placeholder="Enter News Title"
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>News Description</label>
          <textarea
            value={newsDescription}
            onChange={(e) => setNewsDescription(e.target.value)}
            style={styles.textarea}
            placeholder="Enter News Description"
          />
        </div>

        <button style={styles.addButton} onClick={handleAddNews}>
          Add News
        </button>
      </div>

      <h3 style={styles.newsListHeader}>News List</h3>
      <table style={styles.table}>
        <thead>
          <tr style={styles.tableHeaderRow}>
            <th style={styles.tableHeader}>Sr. No.</th>
            <th style={styles.tableHeader}>News Title</th>
            <th style={styles.tableHeader}>News Description</th>
            <th style={styles.tableHeader}>Status</th>
            <th style={styles.tableHeader}>Action</th>
          </tr>
        </thead>
        <tbody>
          {newsList.map((news) => (
            <tr key={news.srNo} style={styles.tableRow}>
              <td style={styles.tableCell}>{news.srNo}</td>
              <td style={styles.tableCell}>{news.title}</td>
              <td style={styles.tableCell}>{news.description}</td>
              <td style={styles.tableCell}>{news.status}</td>
              <td style={styles.tableCell}>
                <button
                  onClick={() => handleToggleStatus(news.srNo)}
                  style={styles.toggleButton}
                >
                  {news.status === "Block" ? "Unblock" : "Block"}
                </button>
                <button
                  onClick={() => handleEditNews(news.srNo)}
                  style={styles.editButton}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    fontSize: "24px",
    color: "#2c3e50",
    marginBottom: "20px",
  },
  formSection: {
    marginBottom: "30px",
  },
  inputGroup: {
    marginBottom: "15px",
  },
  label: {
    fontSize: "14px",
    color: "#34495e",
    marginBottom: "5px",
  },
  input: {
    width: "100%",
    padding: "10px",
    fontSize: "14px",
    color: "#34495e",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    fontSize: "14px",
    color: "#34495e",
    border: "1px solid #ccc",
    borderRadius: "5px",
    height: "100px",
  },
  addButton: {
    padding: "10px 20px",
    backgroundColor: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  newsListHeader: {
    textAlign: "center",
    fontSize: "20px",
    color: "#34495e",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeaderRow: {
    backgroundColor: "#2c3e50",
    color: "#fff",
  },
  tableHeader: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  tableRow: {
    backgroundColor: "#f9f9f9",
    transition: "background-color 0.3s ease",
  },
  tableCell: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  toggleButton: {
    padding: "6px 12px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "10px",
  },
  editButton: {
    padding: "6px 12px",
    backgroundColor: "#f39c12",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default AddNews;
